import { FC } from "react";
import { Outlet } from 'react-router';


export const PublicRoutes: FC<any> = (props: any) => {
    return (
        <Outlet />
    )
}

export default PublicRoutes;